import { faRoad } from '@fortawesome/free-solid-svg-icons';
import { JobHistoryInfo } from './jobhistoryinfo';
import { JobHistoryInfoMetaData } from './jobhistorymetainfo';
import { JobHistoryReasonForLeavingInfo } from './jobhistoryreasons';
import { JobHistoryMetaDataMappings } from './jobHistoryMetaDataMappings';

export class UserJobHistoryListResponse {
  public sessionValid?: any;
  public errorCode?: any;
  public errorMessage?: any;
  public errorMessageData?: any;
  public verificationResult?: any;
  public appExpiry?: any;
  public profileStrengthInfo?: any;
  public resultSize: number = 0;
  public resultPage: number = 0;
  public resultCount: number = 0;
  public reasons: JobHistoryReasonForLeavingInfo[] = [];
  public jobHistories: JobHistoryInfo[] = [];
  public jobHistoryList: JobHistoryInfo[] = [];
  public jobHistoryMetaData: JobHistoryInfoMetaData[] = [];
  public jobHistoryMetaDataMappings: JobHistoryMetaDataMappings[] = [];
  public profiles: JobHistoryMetaDataMappings[] = [];
}
